function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { uniq } from 'lodash/array';
import { device } from '../helpers';
var Infrastructure = /*#__PURE__*/ function() {
    "use strict";
    function Infrastructure() {
        _class_call_check(this, Infrastructure);
        _define_property(this, "data", infrastructureData);
        _define_property(this, "map", null);
        _define_property(this, "persons", {
            icons: null,
            messages: [],
            messagesIndex: 0,
            active: true
        });
        _define_property(this, "markersCluster", null);
        _define_property(this, "$els", {
            open: document.querySelector('[data-infrastructure-filters-open]'),
            close: document.querySelector('[data-infrastructure-filters-close]'),
            filters: document.querySelector('[data-infrastructure-filters]'),
            list: document.querySelector('[data-infrastructure-filters-list]')
        });
    }
    _create_class(Infrastructure, [
        {
            key: "handleCreateFilters",
            value: function handleCreateFilters() {
                var _this = this;
                var filters = this.data.filters;
                var $all = filters.find(function(item) {
                    return item.key === 'all';
                });
                var keys = uniq(this.data.markers.map(function(item) {
                    return item.key;
                }));
                this.$els.list.insertAdjacentHTML('beforeend', '\n                <label class="filters__checkbox">\n                    <input type="checkbox" data-infrastructure-filter-key value="'.concat($all.key, '" checked>\n                    <span class="filters__placeholder">\n                        ').concat($all.icon, "\n                        <span>").concat($all.title, "</span>\n                    </span>\n                </label>\n            "));
                filters.filter(function(item) {
                    return item.key !== 'all';
                }).forEach(function(item) {
                    if (keys.includes(item.key)) {
                        _this.$els.list.insertAdjacentHTML('beforeend', '\n                            <label class="filters__checkbox">\n                                <input type="checkbox" data-infrastructure-filter-key value="'.concat(item.key, '">\n                                <span class="filters__placeholder">\n                                    ').concat(item.icon, "\n                                    <span>").concat(item.title, "</span>\n                                </span>\n                            </label>\n                        "));
                    }
                });
            }
        },
        {
            key: "handleCreateTower",
            value: function handleCreateTower() {
                var _this = this;
                var mediaQuery = window.matchMedia('(max-width: 1100px)');
                var tower = new ymaps.GeoObjectCollection();
                var zoomHide = this.data.settings.zoomHide;
                var _this_data_settings_afi = this.data.settings.afi, icon = _this_data_settings_afi.icon, coords = _this_data_settings_afi.coords;
                var iconLayout = ymaps.templateLayoutFactory.createClass('<div class="tower-placemark tower-placemark_{{properties.className}}"><img src="{{properties.icon}}" alt=""></div>');
                var changeShape = function() {
                    var radius;
                    var className;
                    var zoom = _this.map.getZoom().toFixed(0);
                    if (zoom <= zoomHide) {
                        radius = 50;
                        className = 'zoomed';
                    } else {
                        radius = mediaQuery.matches ? 70 : 95;
                        className = mediaQuery.matches ? 'mobile' : 'desktop';
                    }
                    tower.removeAll();
                    tower.add(new ymaps.Placemark(coords, {
                        icon: icon,
                        className: className
                    }, {
                        iconLayout: iconLayout,
                        hasBalloon: false,
                        hasHint: false,
                        interactiveZIndex: false,
                        zIndex: 9998,
                        iconShape: {
                            type: 'Circle',
                            coordinates: [
                                0,
                                0
                            ],
                            radius: radius
                        }
                    }));
                };
                changeShape();
                mediaQuery.addEventListener('change', changeShape);
                this.map.events.add('boundschange', function(event) {
                    var oldZoom = event.get('oldZoom');
                    var newZoom = event.get('newZoom');
                    if (newZoom.toFixed(0) <= zoomHide && oldZoom.toFixed(0) >= zoomHide + 1) {
                        changeShape();
                    }
                    if (oldZoom.toFixed(0) <= zoomHide && newZoom.toFixed(0) >= zoomHide + 1) {
                        changeShape();
                    }
                });
                this.map.geoObjects.add(tower);
            }
        },
        {
            key: "createMessage",
            value: function createMessage() {
                var _this = this;
                var _this_persons_messages_get;
                var charTimeout = null;
                var nextMessageTimeout = null;
                var text = '';
                var chars = this.data.messages[this.persons.messagesIndex].text.split('');
                var charIndex = 0;
                (_this_persons_messages_get = this.persons.messages.get(this.persons.messagesIndex)) === null || _this_persons_messages_get === void 0 ? void 0 : _this_persons_messages_get.properties.singleSet('message', true);
                var addChar = function() {
                    var _this_persons_messages_get;
                    if (!_this.persons.active) {
                        clearTimeout(charTimeout);
                        clearTimeout(nextMessageTimeout);
                        return false;
                    }
                    text += chars[charIndex];
                    (_this_persons_messages_get = _this.persons.messages.get(_this.persons.messagesIndex)) === null || _this_persons_messages_get === void 0 ? void 0 : _this_persons_messages_get.properties.singleSet('text', text);
                    charIndex += 1;
                    if (charIndex < chars.length) {
                        charTimeout = setTimeout(function() {
                            clearTimeout(charTimeout);
                            addChar();
                        }, 100);
                    } else {
                        nextMessageTimeout = setTimeout(function() {
                            var _this_persons_messages_get;
                            clearTimeout(nextMessageTimeout);
                            (_this_persons_messages_get = _this.persons.messages.get(_this.persons.messagesIndex)) === null || _this_persons_messages_get === void 0 ? void 0 : _this_persons_messages_get.properties.singleSet('message', false);
                            _this.persons.messagesIndex += 1;
                            if (_this.persons.messagesIndex >= _this.persons.messages.getLength()) _this.persons.messagesIndex = 0;
                            _this.createMessage();
                        }, 3500);
                    }
                };
                addChar();
            }
        },
        {
            key: "handleCreateMessages",
            value: function handleCreateMessages() {
                var _this = this;
                if (device.isTouch()) {
                    console.log('Мобильное устройство - иконки людей и сообщения не отображаются');
                    return;
                }
                this.persons.icons = new ymaps.GeoObjectCollection();
                this.persons.messages = new ymaps.GeoObjectCollection();
                var iconLayout = ymaps.templateLayoutFactory.createClass('<div class="message-placemark"><img src="{{properties.icon}}" alt=""></div>');
                this.data.messages.forEach(function(item) {
                    _this.persons.icons.add(new ymaps.Placemark(item.coords, {
                        icon: item.photo
                    }, {
                        iconLayout: iconLayout,
                        cursor: false,
                        hasBalloon: false,
                        hasHint: false,
                        interactiveZIndex: false,
                        iconShape: {
                            type: 'Circle',
                            coordinates: [
                                0,
                                0
                            ],
                            radius: 36
                        },
                        zIndex: 9999
                    }));
                });
                this.map.geoObjects.add(this.persons.icons);
                var iconLayoutMessage = ymaps.templateLayoutFactory.createClass('{% if properties.message %}<div class="message-placemark-balloon">{{properties.text}}</div>{% endif %}');
                this.data.messages.forEach(function(item) {
                    _this.persons.messages.add(new ymaps.Placemark(item.coords, {
                        message: false
                    }, {
                        iconLayout: iconLayoutMessage,
                        cursor: false,
                        hasBalloon: false,
                        hasHint: false,
                        interactiveZIndex: false,
                        iconShape: {
                            type: 'Circle',
                            coordinates: [
                                0,
                                0
                            ],
                            radius: 36
                        },
                        zIndex: 9999
                    }));
                });
                this.map.geoObjects.add(this.persons.messages);
                this.createMessage();
            }
        },
        {
            key: "handleCreateClusters",
            value: function handleCreateClusters() {
                var clusterLayout = ymaps.templateLayoutFactory.createClass('<div class="marker-cluster">{{ properties.geoObjects.length }}</div>');
                this.markersCluster = new ymaps.Clusterer({
                    clusterIconLayout: clusterLayout,
                    clusterIconShape: {
                        type: 'Circle',
                        coordinates: [
                            0,
                            0
                        ],
                        radius: 23
                    },
                    hasBalloon: false,
                    hasHint: false,
                    groupByCoordinates: false,
                    gridSize: 120,
                    zIndex: 9990
                });
            }
        },
        {
            key: "handleCreateMarkers",
            value: function handleCreateMarkers() {
                var _this = this;
                var update = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                if (update) this.markersCluster.removeAll();
                var iconLayout = ymaps.templateLayoutFactory.createClass('<div class="marker-placemark{% if properties.hover %} marker-placemark_hover{% endif %}"><img src="{{properties.icon}}" alt="">{% if properties.title %}<div class="marker-placemark__balloon">{{properties.title}}</div>{% endif %}</div>');
                var markers = [];
                var filters = Array.from(document.querySelectorAll('[data-infrastructure-filter-key]:checked')).map(function($item) {
                    return $item.value;
                });
                this.data.markers.filter(function(item) {
                    return filters.includes(item.key) || filters[0] === 'all';
                }).forEach(function(item) {
                    var key = item.key, title = item.title, coords = item.coords;
                    var marker = new ymaps.Placemark(coords, {
                        title: title,
                        icon: _this.data.filters.find(function(filterItem) {
                            return filterItem.key === key;
                        }).pin,
                        hover: false
                    }, {
                        iconLayout: iconLayout,
                        hasBalloon: false,
                        hasHint: false,
                        iconShape: {
                            type: 'Circle',
                            coordinates: [
                                0,
                                0
                            ],
                            radius: 23
                        }
                    });
                    if (!device.isTouch()) {
                        marker.events.add('mouseenter', function() {
                            marker.properties.singleSet('hover', true);
                            return true;
                        }).add('mouseleave', function() {
                            marker.properties.singleSet('hover', false);
                            return true;
                        });
                    }
                    markers.push(marker);
                });
                this.markersCluster.add(markers);
                if (!update) {
                    this.map.geoObjects.add(this.markersCluster);
                }
            }
        },
        {
            key: "init",
            value: function init() {
                var _this = this;
                ymaps.ready(function() {
                    var _this_data_settings = _this.data.settings, zoom = _this_data_settings.zoom, zoomHide = _this_data_settings.zoomHide, center = _this_data_settings.center;
                    _this.map = new ymaps.Map('infrastructure-map', {
                        center: center,
                        zoom: zoom,
                        controls: []
                    }, {
                        maxZoom: 19
                    });
                    _this.map.behaviors.disable('scrollZoom');
                    if (device.isTouch()) _this.map.behaviors.disable('drag');
                    _this.map.panes.get('ground').getElement().style.filter = 'grayscale(1)';
                    _this.map.controls.add(new ymaps.control.ZoomControl({
                        options: {
                            size: 'small',
                            position: {
                                right: 10,
                                top: 30
                            }
                        }
                    }));
                    _this.map.events.add('boundschange', function(event) {
                        var oldZoom = event.get('oldZoom');
                        var newZoom = event.get('newZoom');
                        if (newZoom.toFixed(0) <= zoomHide && oldZoom.toFixed(0) >= zoomHide + 1) {
                            _this.persons.active = false;
                            _this.persons.icons.removeAll();
                            _this.persons.messages.removeAll();
                            _this.persons.messagesIndex = 0;
                        }
                        if (oldZoom.toFixed(0) <= zoomHide && newZoom.toFixed(0) >= zoomHide + 1) {
                            _this.persons.active = true;
                            _this.handleCreateMessages();
                        }
                    });
                    _this.handleCreateClusters();
                    _this.handleCreateMarkers();
                    _this.handleCreateTower();
                    _this.handleCreateMessages();
                });
                this.handleCreateFilters();
                document.addEventListener('change', function(event) {
                    var $el = event.target;
                    if ($el.dataset.infrastructureFilterKey !== undefined) {
                        if ($el.checked && $el.value === 'all') {
                            document.querySelectorAll('[data-infrastructure-filter-key]:not([value="all"])').forEach(function($item) {
                                $item.checked = false;
                            });
                        } else {
                            Infrastructure.handleChecks();
                        }
                        _this.handleCreateMarkers(true);
                    }
                });
                this.$els.open.addEventListener('click', function(event) {
                    event.preventDefault();
                    _this.$els.filters.classList.add('infrastructure__filters_show');
                    if (window.innerWidth <= 700) window.lenis.stop();
                });
                this.$els.close.addEventListener('click', function(event) {
                    event.preventDefault();
                    _this.$els.filters.classList.remove('infrastructure__filters_show');
                    window.lenis.start();
                });
            }
        }
    ], [
        {
            key: "handleChecks",
            value: function handleChecks() {
                var $checks = Array.from(document.querySelectorAll('[data-infrastructure-filter-key]:not([value="all"])')).map(function($item) {
                    return $item.checked;
                });
                document.querySelector('[data-infrastructure-filter-key][value="all"]').checked = !$checks.find(function(item) {
                    return item;
                });
            }
        }
    ]);
    return Infrastructure;
}();
export default Infrastructure;
